import React from 'react';


const DivStart = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={`d-flex justify-content-start align-items-center ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default DivStart;
